import useSEO from "../hooks/useSEO";
import PageHero from "../components/PageHero";
import ContactSection from "../sections/ContactSection";

export default function Contact() {
  useSEO({
    title: "Contact",
    description: "Start a project with Ideal Entertainment. Tell us your vision and our team will be in touch.",
  });
  return (
    <>
      <PageHero
        overline="Contact"
        title="Let's create something unforgettable"
        subtitle="Tell us about your project — films, music, live events or immersive experiences."
        image="https://images.unsplash.com/photo-1563841930606-67e2bce48b78?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000"
      />
      <ContactSection />
    </>
  );
}
